import { useQuery } from '@tanstack/react-query';

import { useProductCenterApi } from 'api/ApplicationApi';
import { doNotRefetch } from 'api/ReactQueryOptions';
import { getHealthCheckListQuery } from 'api/queries/HealthCheckQueries';
import { ProtocolStatus } from 'api/v1/data-contracts';
import { ParseKeys, TOptions } from 'i18next';

export const useLastHealthCheckDate = ({
	unitPublicId,
	healthCheckIdToSkip,
}: {
	unitPublicId: string;
	healthCheckIdToSkip: number | null;
}): { lastHealthCheckDate: Date | undefined; isLoading: boolean } => {
	const { api } = useProductCenterApi();
	const { data: healthCheckList, isLoading: isListLoading } = useQuery({
		...getHealthCheckListQuery(api, unitPublicId),
		...doNotRefetch,
	});

	const lastHealthCheckDate = healthCheckList
		?.filter((hc) => hc.id !== healthCheckIdToSkip && hc.viewable)
		.sort(
			(a, b) => b.performedDate.getTime() - a.performedDate.getTime()
		)[0]?.performedDate;

	return { lastHealthCheckDate, isLoading: isListLoading };
};

export const formatPerformedBy = (
	userId: string | null,
	businessPartnerName: string | null | undefined
): string =>
	businessPartnerName != null
		? `${userId ?? ''}, ${businessPartnerName}`
		: (userId ?? '');

export const getHealthCheckStatusToTranslationMapping = (
	status: ProtocolStatus | null | undefined
): ParseKeys<['healthCheck'], TOptions, 'healthCheck'> =>
	status
		? (`healthCheck:status-${status}` as const)
		: 'healthCheck:not-saved';
